import http from '../http/http';

import { ADDRESSES, generateEndpoint, ONE_ADDRESS } from '../http/endpoints';

export default (() => {
    const update = (id, params) =>
        http.put(generateEndpoint(ONE_ADDRESS, { id }), params);

    const create = (params) => http.post(generateEndpoint(ADDRESSES), params);

    const createUpdate = (params) =>
        params.id ? update(params.id, params) : create(params);

    return {
        update,
        create,
        createUpdate,
    };
})();
